export class StepRun {
    constructor(provider, invocation, elapsedTime, startTime, endTime, inputs, modelParams, outputs, context) {
        this.provider = provider;
        this.invocation = invocation;
        this.elapsedTime = elapsedTime;
        this.startTime = startTime;
        this.endTime = endTime;
        this.inputs = inputs;
        this.modelParams = modelParams;
        this.outputs = outputs;
        this.context = context;
    }
}
